module.exports = __webpack_public_path__ + "static/media/500032.bcfb0d8a.svg";